import { ErrorFactory } from '@anyx/shared-utils';

import { AnyChatErrorCode } from './constants';

const ERROR_DESCRIPTION_MAP: Record<AnyChatErrorCode, string> = {
  // Not Found
  [AnyChatErrorCode.STORE_NOT_FOUND]: 'STORE_NOT_FOUND',
  [AnyChatErrorCode.CUSTOMER_NOT_FOUND]: 'CUSTOMER_NOT_FOUND',
  [AnyChatErrorCode.CHAT_NOT_FOUND]: 'CHAT_NOT_FOUND',
  [AnyChatErrorCode.INFLUENCER_NOT_FOUND]:
    'anychat.chat.chatAsideHeader.influencer.search.error.notFound',

  // Invalid Data (3000 - 3099)
  [AnyChatErrorCode.BAD_REQUEST]: 'anychat.gql.errors.badRequest',
  [AnyChatErrorCode.INVALID_EMAIL]: 'anychat.gql.errors.invalidEmail',
  [AnyChatErrorCode.INVALID_URL]: 'anychat.gql.errors.invalidUrl',
  [AnyChatErrorCode.INVALID_REDIRECT_URL]: 'anychat.gql.errors.invalidRedirectUrl',
  [AnyChatErrorCode.INVALID_DATEFORMAT]: 'anychat.gql.errors.invalidDateformat',
  [AnyChatErrorCode.INVALID_PHONE_NUMBER]: 'anychat.customer.notify.update.invalid_phone_format',
  [AnyChatErrorCode.NOT_INFLUENCER_MODE_ACCOUNT]: 'anychat.gql.errors.badRequest',
  [AnyChatErrorCode.CUSTOMER_ALREADY_LINKED_TO_INFLUENCER]:
    'anychat.chat.chatAsideHeader.influencer.search.error.customerAlreadyLinked',
  [AnyChatErrorCode.INFLUENCER_ALREADY_LINKED_TO_OTHER_CUSTOMER]:
    'anychat.chat.chatAsideHeader.influencer.search.error.influencerAlreadyLinked',
  [AnyChatErrorCode.INFLUENCER_MERGE_LINKED]:
    'anychat.chat.chatAsideHeader.influencer.search.merge.error.linked',
  [AnyChatErrorCode.INVALID_INFLUENCER_MERGE]:
    'anychat.chat.chatAsideHeader.influencer.search.merge.error.invalid',
  [AnyChatErrorCode.MISSING_PARAM_FOR_TYPE]: 'anychat.gql.errors.missingParamForType',
  [AnyChatErrorCode.MISSING_CRM_ACCOUNT_ID]: 'anychat.gql.errors.missingCrmAccountId',
  [AnyChatErrorCode.INVALID_AUTOMATION_TRIGGER]: 'anychat.gql.errors.invalidAutomationTrigger',
  [AnyChatErrorCode.INVALID_FIELD]: 'anychat.gql.errors.invalidField',
  [AnyChatErrorCode.INVALID_AUTOMATION_CONTENT]: 'anychat.gql.errors.invalidAutomationContent',
  [AnyChatErrorCode.INVALID_BROADCAST_DATA]: 'anychat.gql.errors.invalidBroadcastData',
  [AnyChatErrorCode.INVALID_BROADCAST_STATUS]: 'anychat.gql.errors.invalidBroadcastStatus',
  [AnyChatErrorCode.COUNT_ERROR]: 'anychat.gql.errors.countError',
  [AnyChatErrorCode.RICH_MENU_OVERLAP]: 'anychat.gql.errors.richMenuOverlap',
  [AnyChatErrorCode.INVALID_RICH_MENU_STATUS]: 'anychat.gql.errors.invalidRichMenuStatus',
  [AnyChatErrorCode.INVALID_RICH_MENU_DATA]: 'anychat.gql.errors.invalidRichMenuData',
  [AnyChatErrorCode.EMPTY_FIELD]: 'anychat.gql.errors.emptyField',
  [AnyChatErrorCode.INVALID_TAG]: 'anychat.gql.errors.invalidTag',
  [AnyChatErrorCode.ALREADY_EXISTS]: 'anychat.gql.errors.alreadyExists',
  [AnyChatErrorCode.INCORRECT_ID_TOKEN]: 'anychat.gql.errors.incorrectIdToken',
  [AnyChatErrorCode.INVALID_RICH_MENU_ACTION_SIZE]: 'anychat.gql.errors.invalidRichMenuActionSize',
  [AnyChatErrorCode.INPUT_FIELD_MISSING_NOT_MATCH_TYPE]: 'anychat.gql.errors.fallback',
  [AnyChatErrorCode.NOT_ALLOW_OPERATION_FOR_STATE]: 'anychat.gql.errors.fallback',
  [AnyChatErrorCode.INVALID_TIME_RANGE]: 'anychat.gql.errors.invalidTimeRange',
  [AnyChatErrorCode.MISSING_PARAM_FOR_OPERATION]: 'anychat.gql.errors.fallback',

  // Validation Fail (3101 - 3199)
  [AnyChatErrorCode.MERCHANT_SHOULD_HAVE_ACCOUNT_ID]: 'anychat.gql.errors.fallback',
  [AnyChatErrorCode.UNABLE_TO_DELETE_ACCOUNT_WITH_STORE]:
    'anychat.gql.errors.unableToDeleteAccountWithStore',
  [AnyChatErrorCode.INVALID_RICH_MENU_FAIL_FROM_LINE]:
    'anychat.gql.errors.invalidRichMenuFailFromLine',
  [AnyChatErrorCode.INVALID_RICH_MENU_FILESIZE_TOO_BIG]:
    'anychat.gql.errors.invalidRichMenuFilesizeTooBig',
  [AnyChatErrorCode.INVALID_RICH_MENU_WRONG_IMAGE_SIZE]:
    'anychat.gql.errors.invalidRichMenuWrongImageSize',
  [AnyChatErrorCode.INVALID_RICH_MENU_IMAGE_NOT_MATCH_TEMPLATE]:
    'anychat.gql.errors.invalidRichMenuImageNotMatchTemplate',
  [AnyChatErrorCode.MESSENGER_BROADCAST_ZERO_RECIPIENT]: 'anychat.gql.errors.zeroRecipient',
  [AnyChatErrorCode.MESSENGER_BROADCAST_INVALID_OPERATION]: 'anychat.gql.errors.invalidOperation',
  [AnyChatErrorCode.WHATSAPP_BROADCAST_REQUIRED_OPT_IN]:
    'anychat.gql.errors.whatsappBroadcastRequiredOptIn',
  [AnyChatErrorCode.WHATSAPP_BROADCAST_CARDS_SAME_AMOUNT_BUTTONS_FAIL]:
    'anychat.gql.errors.whatsappBroadcastCardsSameAmountButtonsFail',

  // Not Support (3201 - 3299)
  [AnyChatErrorCode.MIME_TYPE_NOT_SUPPORT_FOR_IMAGE]:
    'anychat.gql.errors.mimeTypeNotSupportForImage',
  [AnyChatErrorCode.MIME_TYPE_NOT_SUPPORT_FOR_VIDEO]:
    'anychat.gql.errors.mimeTypeNotSupportForVideo',
  [AnyChatErrorCode.MESSAGE_TYPE_NOT_ALLOW_VIDEO]: 'anychat.gql.errors.messageTypeNotAllowVideo',
  [AnyChatErrorCode.NOT_SUPPORT_FILE_EXTENSION]: 'anychat.gql.errors.notSupportFileExtension',
  [AnyChatErrorCode.NOT_SUPPORT_MESSAGE_TYPE]: 'anychat.gql.errors.notSupportMessageType',
  [AnyChatErrorCode.MIME_TYPE_NOT_ALLOW]: 'anychat.gql.errors.mimeTypeNotAllow',
  [AnyChatErrorCode.UNRECOGNIZE_MIME_TYPE]: 'anychat.gql.errors.unrecognizeMimeType',
  [AnyChatErrorCode.UNEXPECTED]: 'anychat.gql.errors.unexpected',
  [AnyChatErrorCode.NOT_ALLOW_TAG_SEARCH_WITH_NO_CRITERIA]:
    'anychat.gql.errors.notAllowTagSearchWithNoCriteria',

  // Problem with Data (3301 - 3399)
  [AnyChatErrorCode.REQUIRED_FIELD_IS_MISSING]: 'anychat.gql.errors.requiredFieldIsMissing',

  // External Service Exception (7000 - 7999)
  [AnyChatErrorCode.SHOPEE_REACH_5_MESSAGE_LIMIT]: 'anychat.gql.errors.shopeeReach5MessageLimit',
  [AnyChatErrorCode.SHOPEE_USER_IS_FORBIDDEN]: 'anychat.gql.errors.shopeeUserIsForbidden',
};

interface ErrorParams {
  [AnyChatErrorCode.RICH_MENU_OVERLAP]: {
    overlapIds: string[];
  };
}

export const ANYCHAT_ERROR_FACTORY = new ErrorFactory<AnyChatErrorCode, ErrorParams>(
  'anychat',
  ERROR_DESCRIPTION_MAP
);
